import { useState, useCallback } from "react";

/**
 * Custom hook for managing signature-related state
 * Consolidates signature pad states and handlers
 */
export const useSignatureState = () => {
  // Signature pad refs and states
  const [signaturePadRef, setSignaturePadRef] = useState(null);
  const [personnelSignaturePadRef, setPersonnelSignaturePadRef] =
    useState(null);
  const [hasSignature, setHasSignature] = useState(false);
  const [hasPersonnelSignature, setHasPersonnelSignature] = useState(false);
  const [signatureData, setSignatureData] = useState("");
  const [personnelSignature, setPersonnelSignature] = useState("");

  // Signature handlers
  const clearSignature = useCallback((signaturePad) => {
    if (signaturePad) {
      const ctx = signaturePad.getContext("2d");
      ctx.clearRect(0, 0, signaturePad.width, signaturePad.height);
    }
  }, []);

  const clearMainSignature = useCallback(() => {
    if (signaturePadRef) {
      clearSignature(signaturePadRef);
      setHasSignature(false);
      setSignatureData("");
    }
  }, [signaturePadRef, clearSignature]);

  const clearPersonnelSignature = useCallback(() => {
    if (personnelSignaturePadRef) {
      clearSignature(personnelSignaturePadRef);
      setHasPersonnelSignature(false);
      setPersonnelSignature("");
    }
  }, [personnelSignaturePadRef, clearSignature]);

  const getSignatureData = useCallback((signaturePad) => {
    if (signaturePad) {
      return signaturePad.toDataURL("image/png");
    }
    return null;
  }, []);

  const resetAllSignatures = useCallback(() => {
    clearMainSignature();
    clearPersonnelSignature();
  }, [clearMainSignature, clearPersonnelSignature]);

  return {
    // Signature states
    signaturePadRef,
    personnelSignaturePadRef,
    hasSignature,
    hasPersonnelSignature,
    signatureData,
    personnelSignature,

    // Signature handlers
    clearSignature,
    clearMainSignature,
    clearPersonnelSignature,
    getSignatureData,
    resetAllSignatures,

    // Setters for direct control
    setSignaturePadRef,
    setPersonnelSignaturePadRef,
    setHasSignature,
    setHasPersonnelSignature,
    setSignatureData,
    setPersonnelSignature,
  };
};
